import { Link as MuiLink } from '@mui/material';

export const Link = (props: any) => (<MuiLink {...props} />);
